import { render, staticRenderFns } from "./AnnualLeavePlan.vue?vue&type=template&id=31bbe3f2"
import script from "./AnnualLeavePlan.vue?vue&type=script&lang=js"
export * from "./AnnualLeavePlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports